import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import type { TradeDetailsTabsVariant } from "@/components/custom/trade-details-tabs";

const categoryValues: [TradeDetailsTabsVariant, ...TradeDetailsTabsVariant[]] =
  ["block", "allocation", "message"];

const categoryEnum = z.enum(categoryValues);

const proposedMatchingSearchSchema = z.object({
  sysId: z.coerce.number(),
  wiid: z.coerce.number(),
  ticketType: z.string(),
  category: categoryEnum,
});

export type ProposedMatchingSearch = z.infer<
  typeof proposedMatchingSearchSchema
>;

export const Route = createFileRoute("/proposed-matching")({
  validateSearch: proposedMatchingSearchSchema,
  staticData: { breadcrumb: "Proposed Matching" },
});
